import Select from "react-select";

/**
 * Seletor de ciclo de compras com busca — substitui a fileira de chips (que polui
 * com 8+ ciclos). Reusado no board do Cronograma de Suprimentos e na tela de
 * Configurações. Mostra o ciclo ativo (com contagem opcional de insumos) e, ao abrir,
 * lista pesquisável com badge "padrão".
 *
 * @param {Array<{_id, name, is_default}>} templates
 * @param {string} value  _id do ciclo selecionado (ou ALL_CYCLES)
 * @param {(id: string) => void} onChange
 * @param {(templateId: string) => number} [count]  contagem por ciclo (board); omitir na tela de Config
 * @param {boolean} [disabled]
 * @param {boolean} [allowAll]  inclui a opção "Todos os ciclos" (board; não faz sentido na Config)
 */
export const ALL_CYCLES = "__all__";

const CycleSelect = ({ templates = [], value, onChange, count, disabled = false, allowAll = false }) => {
  const cycleOptions = templates.map((t) => ({
    value: t._id,
    label: t.name,
    is_default: t.is_default,
    count: count ? count(t._id) : null,
  }));
  const options = allowAll
    ? [{
        value: ALL_CYCLES,
        label: "Todos os ciclos",
        is_default: false,
        count: count ? cycleOptions.reduce((a, o) => a + (o.count || 0), 0) : null,
      }, ...cycleOptions]
    : cycleOptions;
  const selected = options.find((o) => o.value === value) ?? null;

  const formatOptionLabel = (opt) => (
    <span className="cycle-option">
      <span className="cycle-option-name">{opt.label}</span>
      {opt.is_default && <span className="cycle-option-tag">padrão</span>}
      {opt.count != null && <span className="cycle-option-count">{opt.count}</span>}
    </span>
  );

  return (
    <Select
      className="basic-select cycle-select"
      classNamePrefix="select"
      isClearable={false}
      isSearchable
      isDisabled={disabled}
      value={selected}
      options={options}
      onChange={(opt) => opt && onChange(opt.value)}
      formatOptionLabel={formatOptionLabel}
      placeholder="Buscar ciclo…"
      noOptionsMessage={() => "Nenhum ciclo encontrado"}
    />
  );
};

export default CycleSelect;
